import { IconButton, Typography} from "@mui/material";
import React from "react";
import MediaIcon from "../../../../assets/icons/mediaIcon";
import FilesIcon from "../../../../assets/icons/filesIcon";
import ShareIcon from "../../../../assets/icons/shareIcon";
import {setAttachments} from "@store/chatSlice.tsx";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";
import {MAX_FILES, MAX_SIZE_MB} from "@config/env.ts";
import { useHasPolicy } from "@config/useHasPolicy";
import { PolicyEnum } from "@config/policyEnum";

interface DrawerActionsProps {
    mediaInputRef: React.RefObject<HTMLInputElement>;
    fileInputRef: React.RefObject<HTMLInputElement>;
    handleShareAction: () => void;
    setIsDrawerOpen: any,
    setFileError:any,   
}


const DrawerActions: React.FC<DrawerActionsProps> = ({
                                                         mediaInputRef,
                                                         fileInputRef,
                                                         handleShareAction,
                                                         setIsDrawerOpen,
                                                         setFileError
                                                     }) => {
    const dispatch = useDispatch<AppDispatch>();
    const attachments = useSelector((state: any) => state.chat.attachments);
    const showMediaAndFilesAttachmentAction = useHasPolicy(PolicyEnum.VIEW_MEDIA_AND_FILES_ICON);
    const editMediaAndFilesAttachmentAction = useHasPolicy(PolicyEnum.EDIT_MEDIA_AND_FILES_ICON);
    const showShareAction = useHasPolicy(PolicyEnum.VIEW_CHAT_SHARE_ACTION);
    const editShareAction = useHasPolicy(PolicyEnum.EDIT_CHAT_SHARE_ACTION);
   
    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if(!files) return;

        const fileArray = Array.from(files);
        const newTotalFiles = attachments.length + fileArray.length;
        const totalSizeMB =
            [...attachments, ...fileArray].reduce((acc, file) => acc + file.size, 0) /
            (1024 * 1024);
        if (newTotalFiles > MAX_FILES) {
            setFileError(`You can only upload up to ${MAX_FILES} files.`);
            return;
        }
        if (totalSizeMB > MAX_SIZE_MB) {
            setFileError(`Total file size should not exceed ${MAX_SIZE_MB}MB.`);
            return;
        }
        setFileError(null);
        dispatch(setAttachments([...attachments, ...fileArray]));
        setIsDrawerOpen(false);
    }

    return (
        <>
        {showMediaAndFilesAttachmentAction &&
            <>
            <IconButton className="flex flex-col items-center cursor-pointer" onClick={() => mediaInputRef.current?.click()} disabled={!editMediaAndFilesAttachmentAction}>
                <Typography>
                    <MediaIcon/>
                </Typography>
                <Typography
                    sx={{
                        marginTop: 1,
                        textTransform: "none",
                        color: "rgba(106, 108, 109, 1)",
                    }}
                >
                    Media
                </Typography>
                <input
                    ref={mediaInputRef}
                    hidden
                    type="file"
                    accept="image/*,video/*"
                    multiple
                    onChange={handleFileUpload}
                />
            </IconButton>

            <IconButton className="flex flex-col items-center cursor-pointer" onClick={() => fileInputRef.current?.click()} disabled={!editMediaAndFilesAttachmentAction}>
                <Typography>
                    <FilesIcon/>
                </Typography>
                <Typography
                    sx={{
                        marginTop: 1,
                        textTransform: "none",
                        color: "rgba(106, 108, 109, 1)",
                    }}
                >
                    Files
                </Typography>
                <input
                    ref={fileInputRef}
                    hidden
                    type="file"
                    multiple
                    onChange={handleFileUpload}
                />
            </IconButton>
            </>}
            {showShareAction &&
            <IconButton
                className="flex flex-col items-center justify-end cursor-pointer"
                onClick={handleShareAction}
                disabled={!editShareAction}
            >
                <Typography>
                    <ShareIcon style={{width: "41px", height: "43px"}}/>
                </Typography>
                <Typography
                    sx={{
                        marginTop: 1,
                        textTransform: "none",
                        color: "rgba(106, 108, 109, 1)",
                    }}
                >
                    Share
                </Typography>
            </IconButton>}
        </>
    );
};

export default DrawerActions;
